<template>
    <v-card
            elevation="2"
            color="white"
            height="210"
            class="overflow-y-auto"
    >
        <v-chip
                  class="ma-1"
                  :color="getGroupColor"
                  text-color="white"
              >
                <div class="text-lg-button">
                  Group: {{this.iconGroupData.groupId}}
                </div>
        </v-chip>
        <v-chip
                  class="ma-1"
                  color="white"
                  text-color="black"
              >
                <div class="text-lg-button">
                  Count: {{this.iconGroupData.icons.length}}
                </div>
        </v-chip>
        <v-chip
                  class="ma-1"
                  color="white"
              >
                <v-btn icon @click="doEdit">
                    <v-icon v-if="isBTRemove" color="gray">mdi-pencil</v-icon>
                    <v-icon v-else color="orange">mdi-pencil</v-icon>
                </v-btn>
        </v-chip>
        <v-chip
                  class="ma-1"
                  color="white"
              >
                <v-btn v-if="this.iconGroupData.isRemoved" icon disabled>
                    <v-icon color="gray">mdi-delete</v-icon>
                </v-btn>
                <v-btn v-else icon @click="doDelete">
                    <v-icon color="red">mdi-delete</v-icon>
                </v-btn>
        </v-chip>
        <v-chip
            v-if="isSwapable"
            class="ma-1"
            color="yellow"
        >
                <v-btn icon @click="this.doSwap">
                    Swap
                </v-btn>
        </v-chip>
        <v-row
            class="pl-2"
            dense no-gutters
        >
             <v-col
                  v-for="it in this.iconGroupData.icons"
                  :key="it"
                  cols="0" sm="0" md="0"
              >
                <v-img
                      :src="getItemIcon(it)"
                      max-width="85px"
                      max-height="85px"
                      dark
                      class="mx-0"
                      @click="doClickOnIcon(it)"
                  >
                    <v-chip
                        v-if="isNotSupportLikeRootIcon(it)"
                        class="ma-2"
                        color="red"
                        text-color="black"
                    >
                      {{getSupportLikeRootIconCounter(it)}}
                    </v-chip>
                    <v-row v-if="isBTRemove">
                        <v-col align="right">
                            <v-btn icon @click="doRemoveIcon(it)">
                                <v-icon color="orange">mdi-delete</v-icon>
                            </v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col align="right">
                            <v-icon class="mx-5" v-if="getSwapSource(it)" color="orange">mdi-thumb-up</v-icon>
                            <v-icon class="mx-5" v-if="getSwapDest(it)" color="orange">mdi-thumb-down</v-icon>
                        </v-col>
                    </v-row>
                </v-img>
                
            </v-col>
            <v-col
                class="pa-5"
                v-if="isBTRemove"
            >
                <v-chip
                    class="ma-1"
                    color="green"
                >
                        <v-btn icon @click="this.doAdd">
                            Add
                        </v-btn>
                </v-chip>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
// import {EVENT_TO_OPEN_ITEM_FORM, EVENT_TO_OPEN_SIBLING_ITEM_FORM, GlobalEvents} from "@/item-editor/events/GlobalEvents";

    export default {
        name: "TransformIconGroupCardItem.vue",
        props:{
            'pIconGroupData':{
                required: true
            },
            'pHeroesIdSupport':{
                required: true
            }
        },
        data() {
            return {
                iconGroupData: null,
                swapSource: '',
                swapDest: '',
                isBTRemove: false,
            }
        },
        created() {
            this.iconGroupData = this.pIconGroupData;
        },
        computed:{
            isSwapable(){
                return this.swapSource != '' && this.swapDest != '';
            },
            getGroupColor(){
                if(this.iconGroupData.isRemoved){
                    return "gray darken-2";
                } else {
                    return "green darken-2";
                }
            }
        },
        methods: {
            getItemIcon(iconName) {
                return require('../../assets/weapons/textures/' + iconName);
            },
            doEdit(){
                this.clearSwap();
                this.isBTRemove = !this.isBTRemove;
            },
            doDelete(){
                this.$emit("OnDeleteGroup", this.iconGroupData.groupId);
            },
            doRemoveIcon(iconName){
                this.isBTRemove = true;
                let payload = {groupId: this.iconGroupData.groupId, iconName: iconName};
                this.$emit("OnRemoveIcon", payload);
            },
            doClickOnIcon(iconName){
                if(!this.isBTRemove){
                    if(iconName == this.swapSource){
                        this.swapSource = '';
                    } else if(iconName == this.swapDest) {
                        this.swapDest = '';
                    } else {
                         if(this.swapSource == ''){
                        this.swapSource = iconName;
                        } else if(this.swapDest == ''){
                            this.swapDest = iconName;
                        } else {
                            this.swapSource = this.swapDest;
                            this.swapDest = iconName;
                        }
                    }
                }
            },
            doSwap(){
                if(this.isSwapable){
                    //if(confirm(`Do you want to swap these two icons in groupId: ${this.iconGroupData.groupId}?`)){
                        let sourceIndex = this.iconGroupData.icons.indexOf(this.swapSource);
                        let destIndex = this.iconGroupData.icons.indexOf(this.swapDest);
                        this.iconGroupData.icons[sourceIndex] = this.swapDest;
                        this.iconGroupData.icons[destIndex] = this.swapSource;
                        this.clearSwap();
                        this.$emit("OnSwaped");
                    //}
                }
            },
            doAdd(){
                this.$emit("ToAddIcon", this.iconGroupData.groupId);
            },
            getSwapSource(iconName){
                return this.swapSource == iconName;
            },
            getSwapDest(iconName){
                return this.swapDest == iconName;
            },
            clearSwap(){
                this.swapDest = '';
                this.swapSource = '';
            },
            getHeroesIdSupportIcon(icon) {
                return this.pHeroesIdSupport[icon];
            },
            isNotSupportLikeRootIcon(icon){
                return this.getSupportLikeRootIconCounter(icon) !== '';
            },
            getSupportLikeRootIconCounter(icon){
                if(this.iconGroupData.icons.length === 0) return '';
                if(this.iconGroupData.icons[0] === icon) return '';
                let rootHeroIds = this.getHeroesIdSupportIcon(this.iconGroupData.icons[0]);
                let heroIds = this.getHeroesIdSupportIcon(icon);
                let count = rootHeroIds.length;
                heroIds.forEach(h => {
                    if(rootHeroIds.includes(h)){
                        count--;
                    }
                });
                if(count > 0){
                    return '-'+count;
                } else if(count < 0){
                    return "+"+count;
                }
                return '';
            }

        },
    }
</script>

<style scoped>
    .v-list--two-line .v-list-item,
    .v-list-item--two-line {
        min-height: 30px;
        height:30px;
    }
</style>